var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83846 10.8732C8.9916 10.8732 13.169 15.0506 13.169 20.2038M3.83846 6.63204C11.3339 6.63204 17.4102 12.7083 17.4102 20.2038M3.83846 2.39087C13.6763 2.39087 21.6514 10.366 21.6514 20.2038M8.04104 18.763C8.04104 20.3349 6.76675 21.6092 5.19483 21.6092C3.62292 21.6092 2.34863 20.3349 2.34863 18.763C2.34863 17.1911 3.62292 15.9168 5.19483 15.9168C6.76675 15.9168 8.04104 17.1911 8.04104 18.763Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogLine);
export default __webpack_public_path__ + "static/media/blog_line.dc1bb3f804f4da548141dc7cae072acb.svg";
export { ForwardRef as ReactComponent };